import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { SignupPoint } from '../services/AdminStats.service';

const STORYBLUE = '#062457';
const STORYGREEN = '#1d7a80';

/** "2026-07-13" -> "Jul 13". Parsed as UTC, matching the server's day buckets. */
const shortDay = (iso: string) => {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
};

const SignupsChart: React.FC<{ series: SignupPoint[]; truncated?: boolean }> = ({ series, truncated }) => {
  const options: ApexOptions = {
    chart: {
      type: 'bar',
      stacked: true,
      toolbar: { show: false },
      fontFamily: 'inherit',
    },
    plotOptions: { bar: { columnWidth: '60%' } },
    dataLabels: { enabled: false },
    grid: { borderColor: '#e5e7eb', strokeDashArray: 4 },
    legend: { position: 'top', horizontalAlign: 'left', markers: { size: 6 } },
    xaxis: {
      categories: series.map((p) => shortDay(p.date)),
      // 30 labels do not fit — show roughly every 5th day.
      tickAmount: 6,
      axisTicks: { show: false },
      labels: { style: { colors: '#6b7280', fontSize: '11px' } },
    },
    yaxis: {
      // Signups are whole people; a fractional gridline would be nonsense on a low-volume day.
      forceNiceScale: true,
      labels: {
        formatter: (v: number) => String(Math.round(v)),
        style: { colors: '#6b7280', fontSize: '11px' },
      },
    },
    tooltip: { y: { formatter: (v: number) => `${v} signup${v === 1 ? '' : 's'}` } },
  };

  const chartSeries = [
    { name: 'Teachers', data: series.map((p) => p.teachers), color: STORYBLUE },
    { name: 'Parents', data: series.map((p) => p.parents), color: STORYGREEN },
  ];

  return (
    <div className="mb-6">
      <h3 className="text-sm font-bold uppercase tracking-wide text-gray-600 mb-2">
        Signups (last 30 days)
        {truncated && <span className="ml-2 font-normal normal-case text-gray-500">· truncated scan</span>}
      </h3>
      <div className="border border-gray-300 rounded-md bg-white p-4">
        <ReactApexChart options={options} series={chartSeries} type="bar" height={260} />
      </div>
    </div>
  );
};

export default SignupsChart;
